import styles from './Header.module.scss';
import clsx from 'clsx';
import { FunctionComponent } from 'react';
import ListItem from './ListItem';
import Search from './Search';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';

interface HeaderProps {
    allLabel: string;
    selectedAll: boolean;
    className?: string;
    hideSearch?: boolean;
    onSearch?: (text: string) => void;
    onSelectAll?: (selected: boolean) => void;
    onClose?: () => void;
}
export const Header: FunctionComponent<HeaderProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <div
                className={styles.closeContainer}
                onClick={props.onClose}
            >
                <FontAwesomeIcon
                    fontSize={20}
                    icon={faTimes}
                />
            </div>
            <>
                {!props.hideSearch && <Search onSearch={props.onSearch} />}
                <ListItem
                    label={props.allLabel}
                    selected={props.selectedAll}
                    onClick={props.onSelectAll}
                />
            </>
        </div>
    );
};

export default Header;
